import Vue from 'vue'
import App from './app'
import router from './router'
import store from './store'
import './core/filter'
import * as base from './utils/base'
import * as validator from './utils/validator'
import * as formatter from './utils/formatter'
import * as transfer from './utils/transfer'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/icon/iconfont.css'
import './assets/iconmenu/iconfont.css'
import './style/global.less'
import './style/transform.less'
import NavMenuItem from './component/layout/NavMenuItem'
import NavPath from './component/layout/NavPath'
import VueCropper from 'vue-cropper'

/** 组件引用 */
Vue.use(ElementUI, {size: 'small'})
Vue.use(VueCropper)
Vue.component('nav-menu-item', NavMenuItem)
Vue.component('nav-path', NavPath)
Vue.config.productionTip = false
Vue.prototype.$base = base
Vue.prototype.$validator = validator
Vue.prototype.$formatter = formatter
Vue.prototype.$transfer = transfer

new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})
